
<template>
    <div class="form-block">

        <div>
            <h2 class="form-block__title mb-3">{{title_form}}</h2>
            <div v-show="step === 1" class="form-block_body">

                <div class="black_block d-flex mb-3">
                    <div class="black_block__title">Category name</div>
                    <input v-model="model_category.name" type="text" class="form-control" :class="{'is-invalid': error_name}">
                    <div @click="clearinput('name')" class="btn-close"></div>
                </div>

                <div class="black_block">
                    <h5>Choose color:
                        {{model_category.icon_base64}}
                    </h5>
                    <div class="colors_block">
                        <input v-model="model_category.icon_base64" class="color_radio" type="radio" value="grey">
                        <input v-model="model_category.icon_base64" class="color_radio" type="radio" value="red">
                        <input v-model="model_category.icon_base64" class="color_radio" type="radio" value="yellow">
                        <input v-model="model_category.icon_base64" class="color_radio" type="radio" value="green">
                        <input v-model="model_category.icon_base64" class="color_radio" type="radio" value="white">
                        <input v-model="model_category.icon_base64" class="color_radio" type="radio" value="lightblue">
                        <input v-model="model_category.icon_base64" class="color_radio" type="radio" value="blue">
                        <input v-model="model_category.icon_base64" class="color_radio" type="radio" value="black">
                    </div>
                </div>
            </div>
            <div v-show="step === 2" class="form-block_body">
                <div class="black_block">
                    <h5>Add persons:</h5>
                    <div class="input_search input_search_border mt-3">
                        <input type="text" placeholder="Search" class="form-control">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
                        </svg>
                    </div>

                    <table class="table mt-3">
                        <tr>
                            <th class="d-flex justify-content-start">
                                <input id="all" type="checkbox" class="custom_checkbox">
                                <label for="all"></label>
                                <span @click="sortName" class="cursor_pointer">
                                    <iconsort :updown="sort_name"></iconsort>
                                    <span>Name</span>
                                </span>
                            </th>
                            <th>ID</th>
                            <th></th>
                        </tr>
                        <tr>
                            <td class="cb">
                                <input id="11112233" type="checkbox" class="custom_checkbox">
                                <label for="11112233"> Orange is the new black</label>
                            </td>
                            <td>11112233</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="cb">
                                <input id="111122333" type="checkbox" class="custom_checkbox">
                                <label for="111122333"> Orange is the new black</label>
                            </td>
                            <td>11113</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="cb">
                                <input id="111223" type="checkbox" class="custom_checkbox">
                                <label for="111223"> Orange is the new black</label>
                            </td>
                            <td>11112233</td>
                            <td></td>
                        </tr>

                    </table>

                </div>
            </div>
        </div>

        <div class="form-block__footer d-flex justify-content-between">

            <div class="form-block__footer_left d-flex justify-content-start align-items-end">
                <button v-show="step === 2" @click="setStep(1)" class="btn btn-link margin-r4">Step back</button>
            </div>
            <div class="form-block__footer_right d-flex justify-content-end align-items-end">
                <button @click="closePopup" class="btn btn-link">Cancel</button>
                <button v-show="step === 2"  @click="setStep(2)" class="btn btn-primary">Next step</button>
                <button v-show="step === 1"  @click="sendCategory" class="btn btn-primary">{{ text_submit }}</button>
            </div>

        </div>

    </div>
</template>

<script>
import {bus} from '../../bus';
import iconsort from "../iconsort";
export default {
    props: ['crud', 'data'],
    data(){
        return{
            title_form: '',
            text_submit: 'Create',
            model_category: {
                name: '',
                icon_base64: 'grey',
                items: [],
            },
            error_name: false,
            step: 1,
            sort_name: 'up'
        }
    },
    methods: {
        clearinput(id){
            if(id === 'name'){
                this.model_category.name = '';
            }
        },
        closePopup(){
            bus.$emit('openpopup' , {
                open: false
            });
        },
        setStep(id){
            this.step = id;
        },
        sendCategory(){
            if(this.validform()){

                if(this.crud === 'create'){
                    bus.$emit('addcategory', this.model_category);
                }

                if(this.crud === 'edit'){
                    bus.$emit('editcategory', this.model_category);
                }

                bus.$emit('openpopup', {
                    open: false
                });

            }

        },
        sortName(){

            if(this.sort_name === 'up'){
                this.sort_name = 'down';
            }else{
                this.sort_name = 'up';
            }
        },
        validform(){

            this.error_name = false;

            if(this.model_category.name === ''){
                this.error_name = true;
                return false;
            }

            return true;

        }
    },
    mounted(){

        if(this.data){
            this.model_category = this.data;
        }

        if(this.crud === 'create'){
            this.title_form = 'Create new category';
            this.text_submit = 'Create';
        }

        if(this.crud === 'edit'){
            this.title_form = 'Update category';
            this.text_submit = 'Update';
        }

    },
    components: {
        iconsort
    }
}
</script>

<style scoped lang="scss">
    .btn-close{
        margin-left: 1rem;
    }
    .colors_block{
        background: var(--color-dark70);
        padding: 1rem;
        display: flex;
        .color_radio{
            cursor: pointer;
            margin: 0 0.5rem;
        }
    }
</style>
